// extracted by mini-css-extract-plugin
export default {"root":"MIRelationshipCard_root__911ab","displayHeader":"MIRelationshipCard_displayHeader__eWIJ9"};